import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function TestimonialsSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const testimonials = [{
    name: 'María Elena',
    age: '54 años',
    quote: 'Llevaba 3 años sin dormir una noche completa. La primera semana con el Método S.C.A., dormí 6 horas seguidas. Lloré de alegría al despertar descansada.',
    delay: '0ms'
  }, {
    name: 'Carmen',
    age: '61 años',
    quote: 'Pensé que era normal no dormir a mi edad. Este ritual me demostró que estaba equivocada. Ahora me duermo en menos de 15 minutos.',
    delay: '150ms'
  }, {
    name: 'Patricia',
    age: '57 años',
    quote: 'Lo que más me sorprendió fue la técnica de Respiración Lunar. Es como un botón de apagado para mi cerebro. Mi esposo no puede creer el cambio.',
    delay: '300ms'
  }];
  return <section className="relative py-24 px-6 z-10 bg-night-800/30 border-y border-gold-500/10" data-id="element-246">
      <div ref={ref} className={`max-w-6xl mx-auto section-reveal ${isVisible ? 'visible' : ''}`} data-id="element-247">
        <div className="text-center mb-16" data-id="element-248">
          <h2 className="text-sm tracking-[0.2em] text-gold-400 uppercase mb-4 font-semibold" data-id="element-249">
            Casos Reales
          </h2>
          <h3 className="text-3xl md:text-5xl font-heading font-bold text-cream-100 leading-tight" data-id="element-250">
            Mujeres como tú ya están durmiendo en paz
          </h3>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-251">
          {testimonials.map((t, i) => <div key={i} className={`glass-card p-8 md:p-10 rounded-3xl relative flex flex-col h-full ${i === 1 ? 'md:translate-y-8' : ''}`} style={{
          transitionDelay: t.delay
        }} data-id="element-252">
              <div className="flex gap-1 mb-6" data-id="element-253">
                {[1, 2, 3, 4, 5].map(star => <SparklesIcon key={star} className="w-5 h-5 text-gold-400 fill-gold-400/20" data-id="element-254" />)}
              </div>

              <p className="text-xl text-cream-100 font-heading italic leading-relaxed mb-8 flex-grow" data-id="element-255">
                "{t.quote}"
              </p>

              <div className="mt-auto pt-6 border-t border-cream-200/10" data-id="element-256">
                <p className="font-heading font-bold text-gold-400 text-lg" data-id="element-257">
                  {t.name}
                </p>
                <p className="text-cream-200/60 text-sm uppercase tracking-wider mt-1" data-id="element-258">
                  {t.age}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}